import { elemLabel, NoAccess } from "./noAccess";
import { asArray, getValue } from "../utils/tools";
import omit from "lodash/omit";
import set from "lodash/set";
import get from "lodash/get";
import { getValidResource } from "./tools";

const getCan = (el) => {
  const resource = getValue(el, "props.resource");
  const action = getValue(el, "props.action");
  let can = getValue(el, "props.can");

  can = can || { resource, action };

  if (get(can, "resource")) {
    can.resource = getValidResource(can.resource);
  }

  return can;
};

export const accessCheck = (acp, list) => {
  return asArray(list)
    .map((el, idx) => {
      if (get(el, "props.skip-acl-check")) return el;

      const label = elemLabel(el);
      const can = getCan(el);

      const allowed = acp.can(can, label);

      el = omit(el, ["props.can"]); //to prevent warning
      set(el, "key", `${idx}-can`);

      return allowed ? (
        el
      ) : (
        <NoAccess label={label} can={can} key={`${idx}-cant`} />
      );
    })
    .filter((v) => v);
};
